import React from 'react'

const Home = ({participantsNumber}) => {
    return (
        <div className='monitor-home'>
            The QR code is currently displayed on the projection screen. <br />
            {participantsNumber} players are connected to this session
        </div>
    )
}

export default Home
